<template>
  <div class="myVirtual_wrap english_container">
    <myHeader />
    <!-- 虚拟制作模块 -->
    <div class="banner">
      <!-- <div style="width: 100%; height: 150px"></div> -->
      <div class="banner_text">
        <p
          style="font-size: 80px; font-weight: 900"
          class="wow fadeInUp enProductTitle"
        >
          Virtual Production xR/VP
        </p>
        <p
          style="margin: 10px auto 0; width: 945px; height: 144px"
          class="wow fadeInUp enTwoProductDesc"
        >
          Expanding the Horizons of Spatial Storytelling—Spatial Composition
          Technology with LED Screens as Shooting Backgrounds
        </p>
        <router-link
          id="xr_vr_contact_us"
          class="callMe zIndexRelative100"
          :to="{ name: 'enCaseDemonstration', hash: '#specific-position' }"
          >Contact Us</router-link
        >
      </div>
    </div>



    <!-- 虚拟制作模块 -->
    <div class="create">
      <p class="wow fadeInUp enProductTitle-mini">About xR</p>
      <p class="wow fadeInUp enProductTitle">
        Virtual Production: Real-World Applications<br />
        of the Concept
      </p>
      <p
        class="text default_font wow fadeInUp"
        style="font-size: 24px; line-height: 34px; font-weight: 500"
      >
        xR technology enables integrated production workflows for film,
        television programs, and live events. By synchronizing camera tracking,
        real-time rendering, and multi-screen playback control systems, it
        maintains precise perspective alignment between virtual environments and
        characters in camera view. Simultaneously, foreground compositing (AR)
        seamlessly blends “characters" with extended virtual elements on the
        screen, creating a cohesive hybrid reality experience.
      </p>
      <!-- <img style="width: 1603px; height: 762px; margin-top: 100px"
        src="https://download.hecoos.com/enlightv/2025-17/79d8c4bea12f4c06941e0a6affd2be81.png" alt=""
        class="wow fadeInUp" /> -->
<!--      <div class="clickShow">-->
<!--        <img-->
<!--          style=""-->
<!--          src="https://download.hecoos.com/enlightv/2025-21/ae06cc29fdd7579611bb910b6ec70cc9.png"-->
<!--          alt=""-->
<!--        />-->
<!--        <div-->
<!--          class="btn_show1 wow fadeInUp"-->
<!--          @click="showCard"-->
<!--          :class="{ blinking: isAnimating }"-->
<!--        ></div>-->
<!--        <div class="xuxian_show1" :style="{ opacity: Card1 ? 1 : 0 }"></div>-->
<!--        <div-->
<!--          class="btn_show2 wow fadeInUp"-->
<!--          @click="showCard1"-->
<!--          :class="{ blinking: isAnimating1 }"-->
<!--        ></div>-->
<!--        <div class="xuxian_show2" :style="{ opacity: Card2 ? 1 : 0 }"></div>-->

<!--        <div-->
<!--          class="btn_show3 wow fadeInUp"-->
<!--          @click="showCard2"-->
<!--          :class="{ blinking: isAnimating2 }"-->
<!--        ></div>-->
<!--        <div class="xuxian_show3" :style="{ opacity: Card3 ? 1 : 0 }"></div>-->
<!--        <div-->
<!--          class="btn_show4 wow fadeInUp"-->
<!--          @click="showCard3"-->
<!--          :class="{ blinking: isAnimating3 }"-->
<!--        ></div>-->
<!--        <div class="xuxian_show4" :style="{ opacity: Card4 ? 1 : 0 }"></div>-->

<!--        <div-->
<!--          class="btn_show5 wow fadeInUp"-->
<!--          @click="showCard4"-->
<!--          :class="{ blinking: isAnimating4 }"-->
<!--        ></div>-->

<!--        <div-->
<!--          class="btn_show6 wow fadeInUp"-->
<!--          @click="showCard5"-->
<!--          :class="{ blinking: isAnimating5 }"-->
<!--        ></div>-->

<!--        <div-->
<!--          class="btn_show7 wow fadeInUp"-->
<!--          @click="showCard6"-->
<!--          :class="{ blinking: isAnimating6 }"-->
<!--        ></div>-->

<!--        <div-->
<!--          class="btn_show8 wow fadeInUp"-->
<!--          @click="showCard7"-->
<!--          :class="{ blinking: isAnimating7 }"-->
<!--        ></div>-->
<!--        <div-->
<!--          class="btn_show9 wow fadeInUp"-->
<!--          @click="showCard8"-->
<!--          :class="{ blinking: isAnimating8 }"-->
<!--        ></div>-->
<!--        <div class="xuxian_show9" :style="{ opacity: Card9 ? 1 : 0 }"></div>-->
<!--        <div-->
<!--          class="btn_show10 wow fadeInUp"-->
<!--          @click="showCard9"-->
<!--          :class="{ blinking: isAnimating9 }"-->
<!--        ></div>-->
<!--        <div class="xuxian_show10" :style="{ opacity: Card10 ? 1 : 0 }"></div>-->
<!--        <div-->
<!--          class="btn_show11 wow fadeInUp"-->
<!--          @click="showCard10"-->
<!--          :class="{ blinking: isAnimating10 }"-->
<!--        ></div>-->
<!--        <div class="xuxian_show11" :style="{ opacity: Card11 ? 1 : 0 }"></div>-->
<!--        <img-->
<!--          :style="{-->
<!--            opacity: Card1 ? 1 : 0,-->
<!--          }"-->
<!--          src="https://download.hecoos.com/enlightv/2025-17/bc1cfab87b04d3ce4ceafaf01c68e004.png"-->
<!--          alt=""-->
<!--          class="card1"-->
<!--        />-->
<!--        <img-->
<!--          :style="{-->
<!--            opacity: Card2 ? 1 : 0,-->
<!--          }"-->
<!--          src="https://download.hecoos.com/enlightv/2025-17/d2512b5bf8dec21164ead667451a8942.png"-->
<!--          alt=""-->
<!--          class="card2"-->
<!--        />-->
<!--        <img-->
<!--          :style="{-->
<!--            opacity: Card3 ? 1 : 0,-->
<!--          }"-->
<!--          src="https://download.hecoos.com/enlightv/2025-17/984a295e7e1d06ee95762e930387d437.png"-->
<!--          alt=""-->
<!--          class="card3"-->
<!--        />-->
<!--        <img-->
<!--          :style="{-->
<!--            opacity: Card4 ? 1 : 0,-->
<!--          }"-->
<!--          src="https://download.hecoos.com/enlightv/2025-17/ff35aa8a951d925ab0137c56aaa3dde1.png"-->
<!--          alt=""-->
<!--          class="card4"-->
<!--        />-->
<!--        <img-->
<!--          :style="{-->
<!--            opacity: Card5 ? 1 : 0,-->
<!--          }"-->
<!--          src="https://download.hecoos.com/enlightv/2025-17/b15e0a04a629d48b991e6a5116f3a021.png"-->
<!--          alt=""-->
<!--          class="card5"-->
<!--        />-->
<!--        <img-->
<!--          :style="{-->
<!--            opacity: Card6 ? 1 : 0,-->
<!--          }"-->
<!--          src="https://download.hecoos.com/enlightv/2025-17/d1815264c2d72c5cc0c5d1d00d9ba01b.png"-->
<!--          alt=""-->
<!--          class="card6"-->
<!--        />-->
<!--        <img-->
<!--          :style="{-->
<!--            opacity: Card7 ? 1 : 0,-->
<!--          }"-->
<!--          src="https://download.hecoos.com/enlightv/2025-17/f8965a1548f9683183d177b83c9366a6.png"-->
<!--          alt=""-->
<!--          class="card7"-->
<!--        />-->
<!--        <img-->
<!--          :style="{-->
<!--            opacity: Card8 ? 1 : 0,-->
<!--          }"-->
<!--          src="https://download.hecoos.com/enlightv/2025-17/c98c21b907b3523a433306356aaa599c.png"-->
<!--          alt=""-->
<!--          class="card8"-->
<!--        />-->
<!--        <img-->
<!--          :style="{-->
<!--            opacity: Card9 ? 1 : 0,-->
<!--          }"-->
<!--          src="https://download.hecoos.com/enlightv/2025-17/5639c06da58e11e936dcb0e513383ae6.png"-->
<!--          alt=""-->
<!--          class="card9"-->
<!--        />-->
<!--        <img-->
<!--          :style="{-->
<!--            opacity: Card10 ? 1 : 0,-->
<!--          }"-->
<!--          src="https://download.hecoos.com/enlightv/2025-17/f8fb827632c9535002c21c9ff5489d50.png"-->
<!--          alt=""-->
<!--          class="card10"-->
<!--        />-->
<!--        <img-->
<!--          :style="{-->
<!--            opacity: Card11 ? 1 : 0,-->
<!--          }"-->
<!--          src="https://download.hecoos.com/enlightv/2025-17/4f5f5179e42b8ea8ac33c945ba324e11.png"-->
<!--          alt=""-->
<!--          class="card11"-->
<!--        />-->
<!--      </div>-->
    </div>

    <div class="create_video">
      <video class="info_video"
             id="intro_video"
             muted src="https://download.hecoos.com/enlightv/2025-48/43229fc3e024f310da39d6dc08f17a55.mp4">

<!--        https://download.hecoos.com/enlightv/2025-47/101575f6280ef1f5c06dfd3a7a193cd3.mp4-->
      </video>
    </div>

    <!-- 变革制作模块 -->
    <div class="transformation">
      <p class="wow fadeInUp enProductTitle-mini" style="margin-bottom: 10px">
        Why Virtual Production?
      </p>
      <p class="wow fadeInUp enProductTitle">Reinvent Your Creative Workflow</p>
      <test class="wow fadeInUp"></test>

      <!-- 2.5D拍摄方案模块 -->
      <div class="plan">
        <p class="wow fadeInUp p1_item">
          2.5D shooting solution
          <br />
          is a hybrid approach
        </p>
        <br />

        <p class="wow fadeInUp p2_item">
          A hybrid approach combining 2D and 3D assets for scene
          construction.<br />
          Utilizes layered images or dynamic content with transparency channels
          to represent different depths of field, including foreground,
          midground, and background elements.<br />
          Compared to fully 3D scene production, 2.5D significantly reduces
          production complexity while remaining compatible with standard 3D
          workflows. It Offers a lightweight and efficient solution for asset
          creation, ideal for teams experienced in 3D scene construction.
        </p>
        <!-- <p>了解更多</p> -->
        <router-link class="more-button wow fadeInUp" to="/en/Understand"
          >Learn More</router-link
        >
      </div>
    </div>

    <!-- 应用场景模块 -->
    <div class="application">
      <p
        style="font-size: 60px; font-weight: 700; margin-bottom: 30px"
        class="wow fadeInUp enProductTitle"
      >
        Application Scenarios
      </p>
      <p style="color: #b8b8b8" class="wow fadeInUp">
        Practical Applications of hecoos xR/VP
      </p>
      <myBanner
        :applicationInfo="applicationInfo"
        class="wow fadeInUp"
      ></myBanner>
    </div>

    <!-- 产品模块 -->
    <div class="product colorBlack">
      <div class="tab">
        <p class="enProductTitle wow fadeInUp" style="margin-bottom: 0px">
          PRODUCT
        </p>
        <p
          style="font-size: 60px; font-weight: 700; margin-top: 12px"
          class="wow fadeInUp enProductTitle"
        >
          Your Virtual Production Toolkit
        </p>
        <div class="switch" ref="switch_list">
          <!-- 为每个 span 绑定点击事件和动态类名 -->
          <span
            :class="{ select: currentTabIndex === 0 }"
            @click="selectTab(0)"
          >
            Server-C
          </span>
          <span
            :class="{ select: currentTabIndex === 1 }"
            @click="selectTab(1)"
          >
            Server-R
          </span>
          <span
            :class="{ select: currentTabIndex === 2 }"
            @click="selectTab(2)"
          >
            Server-D
          </span>
          <div
            class="underline"
            :style="{
              width: underlineWidth + 'px',
              left: underlineLeft + 'px',
            }"
          ></div>
        </div>
      </div>
      <!-- 产品内容部分 -->
      <div>
        <div class="content">
          <div class="studio" v-show="showContents[0]">
            <div class="layout">
              <img
                src="https://download.hecoos.com/enlightv/2025-17/04d5ec07fa899de9a432f1229ce2e14a.png"
                alt=""
                class=""
              />
              <div class="textContent">
                <p class="enProductTitle" style="margin-bottom: 55px">
                  Server-C
                </p>
                <p class="enProductCont" style="margin-bottom: 90px">
                  As the "core hub" of the virtual production process, it can be
                  professionally customized based on on-site requirements,
                  making it an essential choice for your virtual production
                  needs.
                </p>
                <router-link
                  class="know_call"
                  :to="{ path: '/en/mediaServer?section=1', hash: '#tab' }"
                >
                  Learn more
                </router-link>
              </div>
            </div>
          </div>
          <div class="studio" v-show="showContents[1]">
            <div class="layout">
              <img
                src="https://download.hecoos.com/enlightv/2025-17/84ed7b41f8f729ee36615a27ffed63f9.png"
                alt=""
              />
              <div class="textContent">
                <p class="enProductTitle" style="margin-bottom: 55px">
                  Server-R
                </p>
                <p class="enProductCont" style="margin-bottom: 90px">
                  When faced with heavy and complex real-time rendering tasks,
                  the powerful rendering capabilities of hecoos Server-R can
                  also provide thoughtful support for virtual content creators
                </p>
                <router-link
                  class="know_call"
                  :to="{ path: '/en/mediaServer?section=2', hash: '#tab' }"
                >
                  Learn more
                </router-link>
              </div>
            </div>
          </div>
          <div class="studio" v-show="showContents[2]">
            <div class="layout">
              <img
                src="https://download.hecoos.com/enlightv/2025-17/312c08f1ed29d3fb2bde6056292ed57a.png"
                alt=""
              />
              <div class="textContent">
                <p class="enProductTitle" style="margin-bottom: 55px">
                  Server-D
                </p>
                <p class="enProductCont" style="margin-bottom: 70px">
                  Relying on the hecoos workflow, we maximize control over every
                  aspect from conceptual inspiration to final presentation,
                  embodying the product design philosophy of "Design is
                  realization.
                </p>
                <router-link
                  class="know_call"
                  :to="{ path: '/en/mediaServer?section=0', hash: '#tab' }"
                >
                  Learn more
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 我们正年轻模块 -->
    <div class="section_foundation">
      <div class="section_content">
        <p class="carousel-title wow fadeInUp" style="font-size: 60px">
          Honkai lmpact 3 "Innocent Dream Song"
        </p>
        <button class="watch-movie-button wow fadeInUp" @click="showVideo">
          <img src="https://download.hecoos.com/enlightv/2025-37/9d124e6eba23d44a2c6f6cd6aa75901f.svg" alt="" />
          <p style="font-size: 20px; font-weight: 700">Watch the Video</p>
        </button>
      </div>
      <div class="scroll_container">
        <div class="foundation_video">
          <video
              autoplay
              loop
              muted
              src="https://download.hecoos.com/enlightv/2025-48/7aa35bc6bfbdb6acd299ab6414915a22.mp4"
          ></video>
        </div>
      </div>
    </div>
    <!-- 创意模块 -->
    <Creativity :imgUrl="imgUrl" :isColor="true" />

    <!-- 技术指南模块 -->
    <div class="guidebook">
      <div class="guidebook_layout">
        <div class="left">
          <img
            src="https://download.hecoos.com/enlightv/2025-17/87d4423d9f2bfcec8d5a3139b927ae0d.png"
            alt=""
            class="wow fadeInUp"
          />
        </div>
        <div class="rig">
          <p class="wow fadeInUp enProductTitle" style="margin-bottom: 55px;">Operation Guide</p>
          <p class="enProductCont wow fadeInUp">
            Learn why Extended Reality (xR) is the ultimate next-generation
            storytelling tool for live productions and the technologies that
            make it possible.
          </p>
          <!-- <div class="vir_call wow fadeInUp">Download Guide</div> -->
          <div class="vir_call wow fadeInUp">
            <a href="https://download.hecoos.com/hecoos/hecoosGuide.pdf"
              >Download Guide</a
            >
          </div>
        </div>
      </div>
    </div>
    <myText :reviews="reviews" />
    <myFooter />
    <BackToTop />
    <videoPlayback
      v-if="showVideoPlayer"
      @close="handleCloseVideo"
      :videoUrl="videoUrl"
    />
  </div>
</template>

<script>
import myHeader from "@/components/en_pc/myHeader.vue";
import myFooter from "@/components/en_pc/myFooter.vue";
import Creativity from "@/components/en_pc/creativity";
import myBanner from "@/components/en_pc/myBanner";
import BackToTop from "@/components/en_pc/BackToTop";
import test from "@/components/en_pc/myTest.vue";
import videoPlayback from "@/components/en_pc/videoPlayback.vue";
import myText from "@/components/en_pc/myText.vue";

import Swiper from "swiper";
import "swiper/css/swiper.min.css";

export default {
  data() {
    return {
      isAnimating: true,
      isAnimating1: true,
      isAnimating2: true,
      isAnimating3: true,
      isAnimating4: true,
      isAnimating5: true,
      isAnimating6: true,
      isAnimating7: true,
      isAnimating8: true,
      isAnimating9: true,
      isAnimating10: true,
      Card1: false,
      Card2: false,
      Card3: false,
      Card4: false,
      Card5: false,
      Card6: false,
      Card7: false,
      Card8: false,
      Card9: false,
      Card10: false,
      Card11: false,
      underlineWidth: 0,
      underlineLeft: 0,
      imgUrl:
        "https://download.hecoos.com/enlightv/2025-17/70a8a0bd16927f414fc5369552198623.png",
      bannerList: [
        {
          url: "https://download.hecoos.com/enlightv/2025-17/718decc418a0bd5a7d8ee9b25003372b.png",
        },
        {
          url: "https://download.hecoos.com/enlightv/2025-17/718decc418a0bd5a7d8ee9b25003372b.png",
        },
      ],
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 0,
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false, false],
      applicationInfo: [
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/ee5f23b3104fb4be10721778c0a997c4.png",
          title: "Film and Television Productions",
          msg: "Create immersive 3D story scenes, using real-time fusion of virtual and real environments to tell stories. The previsualization workflow provides directors with an intuitive preview of shooting effects.",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/a25155afdd5ee47a4ce313ed0edb8797.png",
          title: "TVC Advertising",
          msg: "Quickly build the shooting space required for advertising creativity, enabling efficient presentation of ideas.",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/ad529ec82ee802875c26931e8fe7264e.png",
          title: "Broadcast Television Programs",
          msg: "hecoos brings a new, efficient, and organized experience to broadcast television program production through an integrated workflow, covering key aspects such as virtual special effects packaging, precise director switching, lighting synchronization with program content, and audio-visual playback control.",
        },
      ],
      Card1: false,
      showVideoPlayer: false,
      videoUrl:
        "https://download.hecoos.com/enlightv/2025-48/7aa35bc6bfbdb6acd299ab6414915a22.mp4",
      reviews: [
        {
          content:
            "The hecoos xR virtual production system seamlessly integrates the innovative workflow of 'post-production pre-positioning,’ solving nearly all potential issues from the source. Automated color calibration, positioning and tracking technologies save time and effort. The highly integrated system lowers the technical barrier for users, making it fast to learn and easy to operate.",
          author: "Liu Chang",
          position: "Deputy Director, Virtual Production Experiment Center",
          institution:
            "School of Drama and Film and Television, Nanjing University of the Arts",
        },
        {
          content:
            "Wanderer represents a brand-new attempt in the production approach of Chinese science fiction films. It took only 12 days to complete all the shooting work for a 90-minute film, which is also a minor miracle in the production of science fiction films. The virtual shooting process of hecoos provided a guarantee for more efficient production and stunning visual presentation, making the entire production process very smooth and demonstrating the huge potential of virtual shooting technology in science fiction films.",
          author: "Zou Jie",
          position: "Producer of 'The Wanderer",
          institution: "",
        },
      ],
    };
  },
  components: {
    myHeader,
    myFooter,
    Creativity,
    myBanner,
    BackToTop,
    test,
    videoPlayback,
    myText,
  },
  methods: {
    scrollVideoPlay() {
      if(this.is_video_play){return false}
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const intro_video = document.getElementById('intro_video')
      if(intro_video ){
        if (scrollTop >= intro_video.offsetTop - intro_video.offsetHeight && scrollTop < intro_video.offsetTop + intro_video.offsetHeight) {
          this.is_video_play = true
          intro_video.play()
        }
      }
    },
    showCard() {
      this.Card1 = !this.Card1;
      this.isAnimating = false;
    },
    showCard1() {
      this.Card2 = !this.Card2;
      this.isAnimating1 = false;
    },
    showCard2() {
      this.Card3 = !this.Card3;
      this.isAnimating2 = false;
    },
    showCard3() {
      this.Card4 = !this.Card4;
      this.isAnimating3 = false;
    },
    showCard4() {
      this.Card5 = !this.Card5;
      this.isAnimating4 = false;
    },
    showCard5() {
      this.Card6 = !this.Card6;
      this.isAnimating5 = false;
    },
    showCard6() {
      this.Card7 = !this.Card7;
      this.isAnimating6 = false;
    },
    showCard7() {
      this.Card8 = !this.Card8;
      this.isAnimating7 = false;
    },
    showCard8() {
      this.Card9 = !this.Card9;
      this.isAnimating8 = false;
    },
    showCard9() {
      this.Card10 = !this.Card10;
      this.isAnimating9 = false;
    },
    showCard10() {
      this.Card11 = !this.Card11;
      this.isAnimating10 = false;
    },
    goVedio() {
      window.open(
        "https://download.hecoos.com/enlightv/2025-11/3682ee8f4d99851fede9ebb32b9f1b10.mp4"
      );
    },
    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      this.currentTabIndex = index;
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      this.updateUnderlinePosition();
    },
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },
    // 显示视频播放器
    showVideo() {
      this.showVideoPlayer = true;
      document.body.style.overflow = "hidden"; // 禁止页面滚动
    },
    // 处理关闭视频
    handleCloseVideo() {
      this.showVideoPlayer = false;
      document.body.style.overflow = "auto"; // 恢复页面滚动
    },
  },
  mounted() {
    new Swiper(this.$refs.swiper, {
      autoplay: {
        delay: 5000,
        // 交互后保持自动播放
        disableOnInteraction: true,
      },
      pagination: {
        el: ".swiper-pagination",
        // 可点击
        clickable: true,
      },
      // 禁用滑动
      allowTouchMove: false,
    });
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      window.addEventListener("resize", this.updateUnderlinePosition);
    });
    window.addEventListener('scroll', this.scrollVideoPlay);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateUnderlinePosition);
    window.removeEventListener('scroll', this.scrollVideoPlay);
  },
};
</script>

<style scoped lang="scss">
/* 虚拟制作模块 */
@import "@/styles/en_pc/xty.scss";
@import "@/styles/optimize_adaptation.scss";

.underline {
  position: absolute;
  bottom: 0;
  height: 3px;
  background-color: #7948ea;
  transition: all 0.3s ease;
}

.callMe {
  display: inline-block;
  text-decoration: none;
  padding: 16px 24px;
  line-height: 32px;
  border-radius: 40px;
  background-color: #147cf5;
  margin: 0 auto;
  margin-top: 100px;
  font-size: 22px;
  cursor: pointer;
  color: #fff;
  transition: all 0.3s ease;
}

.callMe:hover {
  transform: scale(1.05);
  background-color: #fff;
  color: #147cf5;
}
.myText_wrap{
  background-color: #121416;
}
</style>
